import {
  array,
  type InferOutput,
  number,
  object,
  optional,
  string
} from 'valibot'

import { MonthlyCustomerReportSearchValidateSchema } from './monthly-customer-report-search'

/**
 * 日付範囲明細（請求）の search (#4829)。
 *
 * `listSearch` は遷移元一覧の search そのもの。「一覧へ戻る」で一覧の条件とページを復元し、
 * その荷主の絞り込み・拠点を API に一覧の入力として渡す（明細を一覧と同じ母集団から作るため）。
 */
export const MonthlyCustomerReportDateRangeDetailSearchValidateSchema = object({
  customerId: number(),
  operatingDateFrom: string(), // 計上日 from (yyyy-MM-dd)
  operatingDateTo: string(), // 計上日 to (yyyy-MM-dd)
  dcIds: optional(array(number())),
  page: optional(number()),
  take: optional(number()),
  listSearch: optional(MonthlyCustomerReportSearchValidateSchema)
})

export type MonthlyCustomerReportDateRangeDetailSearch = InferOutput<
  typeof MonthlyCustomerReportDateRangeDetailSearchValidateSchema
>
